export default __webpack_public_path__ + "static/media/logo-progenos.caa089b6.svg";